/**
 * displays the page where users edit the employer profile page
 */
import React from 'react';
import PropTypes from 'prop-types';
import ProfileImageHandler from './ProfileImageHandler';
import i18n from '../../../../shared/locales/no.json';
import ProfileHeader from '../../../components/employerProfile/ProfileHeader';
import { connect } from 'react-redux';
import { uploadBackground } from '../../../actions/profileActions';

export class EditableHeader extends React.Component {
    static propTypes = {
        dispatch: PropTypes.func.isRequired,
        loadingProfileBackground: PropTypes.bool,
        profile: PropTypes.shape({
            background: PropTypes.string,
            id: PropTypes.number.isRequired,
        }).isRequired,
    };

    getProfileBg() {
        if (this.props.profile.background) {
            return {
                backgroundImage: `url(${this.props.profile.background})`,
            };
        }
    }

    onUploadBackground = (id, data) => {
        this.props.dispatch(uploadBackground(id, data));
    };

    renderBackgroundImgComponent() {
        return (
            <ProfileImageHandler
                classes="button button--small"
                fieldName="background"
                loading={this.props.loadingProfileBackground}
                profileId={this.props.profile.id}
                uploadBackground={this.onUploadBackground}
            >
                {i18n['Change background image']}
            </ProfileImageHandler>
        );
    }

    render() {
        return (
            <ProfileHeader
                backgroundImgComponent={this.renderBackgroundImgComponent()}
                style={this.getProfileBg()}
            />
        );
    }
}

export default connect(() => ({}))(EditableHeader);
